import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CtaBlock() {
  const goContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="cta-block-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#0E0E0E]">
          <div className="absolute inset-0 bg-grid opacity-50 [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_75%)]" />
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full bg-blue-500/15 blur-[120px]" />
          <div className="relative p-10 md:p-16 text-center">
            <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
              Free, no-pressure
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1] max-w-3xl mx-auto">
              Want to see what your website{" "}
              <span className="italic">could look like</span>?
            </h2>
            <p className="mt-6 text-white/65 max-w-xl mx-auto text-[15px] md:text-base">
              I can make a quick concept or review your current site and show
              you what could be improved — no commitment, no fluff.
            </p>
            <div className="mt-8">
              <Button
                data-testid="cta-block-button"
                onClick={goContact}
                className="bg-blue-500 hover:bg-blue-600 text-white rounded-full h-12 px-8 text-sm font-medium shadow-[0_10px_40px_-10px_rgba(59,130,246,0.6)]"
              >
                Request a Free Website Review
                <ArrowUpRight size={16} className="ml-1.5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
